function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path fill="#fff" d="M10.275 32v-9.415H0V9.374h10.275V0l21.859 16zM2.936 19.649h10.275v6.561l13.954-10.211L13.211 5.785v6.525H2.936v7.339z" /></svg>;
});